<template>
  <div
    class="yhc-ef-item-list--item-kaguido-option yhc-ef-item-list--item-content"
    v-if="kazaiData?.kazaiType"
  >
    <div class="option-label">ちょこっと模様替え</div>
    <button
      type="button"
      @click.prevent.stop="() => removeKazai()"
      class="btn-close yhc-ef-item-list--item--delete-button"
      aria-label="Close"
    />
    <div class="yhc-ef-item-list--item--inner d-flex">
      <div class="kazai-image">
        <img
          style="max-height: 80px"
          v-if="kazaiData.kazaiType.thumbnail"
          :src="$core.$imgix.buildUrl(kazaiData.kazaiType.thumbnail)"
          alt=""
        />
      </div>
      <div class="kazai-description">
        <p class="kazai-name bold mb-2">
          {{ kazaiData.kazaiType.name }}
          <span
            v-if="kazaiData.kazaiType.displayNameFormEnabled"
            class="bold"
            >({{ kazaiData.userInputName }})</span
          >
        </p>
        <div
          v-if="
            kazaiData.totalPrice &&
            Object.keys(kazaiData.availableSelectedOptionsByServiceId).length !== 0
          "
          class="selected-options"
        >
          <p class="bold mb-1">オプション料金</p>
          <ul>
            <li
              v-for="(selections, sId) in kazaiData.availableSelectedOptionsByServiceId"
              class="selected-option-item"
            >
              <p
                v-for="(selection, oId) in selections"
                class="mb-1"
              >
                {{ selection.title }}: ¥{{ selection.price.toLocaleString() }}
              </p>
            </li>
          </ul>
        </div>
        <div class="selected-destinations">
          <p class="bold mb-1">移動先</p>
          <ul>
            <li
              v-for="selection in selectedDestinationQuestionsAndAnswers"
              class="selected-destination-item"
            >
              <p class="mb-0">
                {{ selection.questionTitle }}: {{ selection.optionText }}
              </p>
            </li>
          </ul>
          <p class="text-right bold">
            移動先料金: ¥
            {{ selectedDestinationPrice }}
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between pt-1">
      <div>
        <button
          type="button"
          @click.prevent="() => editKazai()"
          class="yhc-ef-item-list--item--modify-btn hover-fade"
          aria-label="修正"
        >
          修正
        </button>
      </div>
      <p class="bold text-right kazai-total-price">
        小計: ¥
        <span v-if="kazaiData.totalPrice">{{
          kazaiData.totalPrice.toLocaleString()
        }}</span>
        <span v-else>-</span>
      </p>
    </div>
    <b-modal
      ref="editKazaiModal"
      title="移動したいお荷物の種類や移動先、オプションを選択してください"
      size="md"
      dialog-class="yhc-ef-modal-dialog--kazaiForm"
      ok-only
      ok-title="戻る"
      ok-variant="outline-secondary"
      title-class="bg-light"
      class="yhc-modal"
      no-close-on-backdrop
      no-close-on-esc
    >
      <YhcEFKazaiKaguidoDetailInput
        :subCategoryId="kazaiData.kazaiType.subCategory.id"
        :existing-kazai-data="kazaiData"
        :isKaguidoFrom="isKaguidoFrom"
        @addKazai="(_kazaiData) => updateKazaiData(_kazaiData)"
      />
    </b-modal>
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import { YhcEFInputOneKazaiTypeDataObjectForKaguidoOption } from '../../YhcEFInputOneKazaiTypeDataObjectForKaguidoOption'
import YhcEFKazaiKaguidoDetailInput from '../YhcEFKazaiKaguidoDetailInput/YhcEFKazaiKaguidoDetailInput.vue'
import {
  ModelKazaiKaguidoOptionDestinationQuestionAndAnswer,
  ModelYhcKazaiKaguidoDestinationOptionsAndPrices,
} from '../../../../fireModels/yhcDataTypes'

export default {
  components: { YhcEFKazaiKaguidoDetailInput },
  props: {
    kazaiData: {
      type: Object as PropType<YhcEFInputOneKazaiTypeDataObjectForKaguidoOption>,
      required: false,
    },
    isKaguidoFrom: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    selectedDestinationQuestionsAndAnswers(): ModelKazaiKaguidoOptionDestinationQuestionAndAnswer[] {
      return Object.values(
        this.kazaiData.selectedDestinationQuestionAndAnswerByQuestionId,
      )
    },
    selectedDestinationPrice(): string {
      return Object.values(
        this.kazaiData.selectedDestinationQuestionAndAnswerByQuestionId,
      )
        .reduce((acc, q) => acc + (q.additionalPrice || 0), 0)
        .toLocaleString()
    },
    isContainUnavailableArea(): boolean {
      return !!this.kazaiData?.$efs?.$userInputData?.isContainUnavailableArea
    },
  },
  watch: {
    isContainUnavailableArea(unavailable: boolean) {
      if (unavailable) {
        this.$refs.editKazaiModal?.hide?.()
      }
    },
  },
  methods: {
    editKazai() {
      this.$refs.editKazaiModal.show()
    },
    updateKazaiData(kazaiData) {
      if (this.isKaguidoFrom) {
        this.kazaiData.$efs.$userInputData.updateKazaiDataForKaguidoOptionCollectionDestination(
          kazaiData,
        )
      } else {
        this.kazaiData.$efs.$userInputData.updateKazaiDataForKaguidoOptionDeliveryDestination(
          kazaiData,
        )
      }
      this.$refs.editKazaiModal.hide()
    },
    async removeKazai() {
      if (
        await $core.$toast.confirmDialog(
          `"${this.kazaiData.kazaiType.name}" を削除しますか？`,
        )
      ) {
        if (this.isKaguidoFrom) {
          this.kazaiData.$efs.$userInputData.removeKazaiDataByIdForKaguidoOptionCollectionDestination(
            this.kazaiData.id,
          )
        } else {
          this.kazaiData.$efs.$userInputData.removeKazaiDataByIdForKaguidoOptionDeliveryDestination(
            this.kazaiData.id,
          )
        }
      }
    },
  },
}
</script>
